import { useEffect, useRef } from "react";

const IFRAME_ORIGIN =
  "https://prijave.slavonska-biciklisticka-udruga.hr";

export const Calendar = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      const iframe = iframeRef.current;

      if (!iframe) return;
      if (e.origin !== IFRAME_ORIGIN) return;
      if (e.source !== iframe.contentWindow) return;

      const height = Number(e.data?.sbbl_visina);

      if (!Number.isFinite(height) || height <= 0) return;

      const newHeight = Math.ceil(height);
      const currentHeight = iframe.getBoundingClientRect().height;

      if (Math.abs(currentHeight - newHeight) < 2) return;

      iframe.style.height = `${newHeight}px`;
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="max-w-[1440px] mx-auto pt-[80px] pb-[40px] lg:pb-[80px] lg:pt-[120px]">
      <div className="space-y-[24px] px-[16px]">
        <iframe
          ref={iframeRef}
          id="sbbl-prijave"
          src={`${IFRAME_ORIGIN}/sbbl/?embed=1`}
          title="Prijave na utrke SBBL"
          loading="lazy"
          scrolling="no"
          style={{
            display: "block",
            width: "100%",
            height: "900px",
            border: 0,
            overflow: "hidden",
          }}
        />
      </div>
    </div>
  );
};
